import { Box } from "@mui/material";
import EmptyState from "~/components/EmptyState";

const NotFoundPage = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" flex="1">
      <EmptyState
        label="404"
        labelStyles={{
          fontSize: 44,
          fontWeight: 600,
        }}
      />
    </Box>
  );
};

export default NotFoundPage;
